import React, {useState} from "react";
import HostNav from "../components/hostComponents/HostNav";
import TextBox2 from "../components/TextBox2";
import request from "../utils/request";
import {useSelector} from "react-redux";
import { ToastContainer, toast } from "react-toastify";

function HostDashboard() {
    const [token, setToken] = useState('')
    const { hostInfo } = useSelector((state) => state.host);
    const [loading, setLoading] = useState(false);
    const submit = async () => {
        if (!token) {
            toast.error('Please enter a token');
            return;
        }
        setLoading(true);
        try {
            const response = await request.post(`/hosts/save-guesty-status/${hostInfo._id}`, { token }, { withCredentials: true });

            if (response.data.success) {
                toast.success(response.data.msg || 'Token saved successfully!');
            } else {
                toast.error(response.data.msg || 'Failed to save token');
            }
            setToken('')
            setLoading(false);
            const hostData = localStorage.getItem('hostInfo')
            const data = JSON.parse(hostData);
            data.guesty_client_id = response.data.guesty_client_id;
            data.guesty_client_secret = response.data.guesty_client_secret;
            localStorage.setItem("hostInfo", JSON.stringify(data));
            // Update Redux state instead of reloading
            // The UI will update automatically through Redux state changes
        } catch (error) {
            if (error.response?.data?.message || error.response?.data || error.message === 'Unauthenticated') {
                toast.error('The token is invalid or expired. Please check and try again.');
            } else {
                toast.error(error.response?.data?.message || error.response?.data || error.message || 'An unexpected error occurred.');
            }
            setLoading(false);
        }
    };

    const syncGuestyProperties = async () => {
        setLoading(true);
        await request.post(`/hosts/sync-guesty-properties/${hostInfo._id}`, {}, {
            withCredentials: true
        }).then((response) => {
            toast.success(response.data.msg)
        });
        setLoading(false);
    }

    const handleDeleteGuestyConnection = async () => {
        const confirmation = window.confirm("Are you sure you want to delete the Guesty connection?");
        if (confirmation) {
            setLoading(true);
            try {
                const response = await request.get(`/hosts/disconnect-guesty/${hostInfo._id}`, { withCredentials: true });
                if (response.data.success) {
                    toast.success(response.data.msg || 'Guesty connection deleted successfully!');
                    const hostData = localStorage.getItem('hostInfo')
                    const data = JSON.parse(hostData);
                    data.guesty_client_id = null;
                    data.guesty_client_secret = null;
                    localStorage.setItem("hostInfo", JSON.stringify(data));
                    window.location.reload();
                } else {
                    toast.error(response.data.msg || 'Failed to delete Guesty connection');
                }
            } catch (error) {
                toast.error(error.response?.data?.message || error.response?.data || error.message || 'An unexpected error occurred.');
            }
            setLoading(false);
        }
    };


    return (
        <div className="flex w-full h-screen overflow-auto">
            <div className="flex flex-col w-full mobile:w-full px-10 tablet:px-0 mx-auto">
                <HostNav dashboard={true} hideproperty={true}/>
                {!hostInfo.guesty_client_id && !hostInfo.guesty_client_secret ? (
                    <div className="w-[95%] form pt-5">
                        <div className="flex items-center gap-x-7 mobile:flex-col">
                            <TextBox2
                                label={"Guesty Token"}
                                name='token'
                                value={token}
                                setValue={(value) => {
                                    setToken(value.token);
                                }}
                                placeholder={"Enter Guesty token here"}
                            />
                        </div>
                        <button
                            onClick={submit}
                            disabled={loading}
                            className={`mt-4 bg-[#00B227] text-white font-bold py-2 px-4 rounded-lg transition-all hover:bg-green-600 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                            {loading ? "Saving..." : "Connect to Guesty"}
                        </button>
                    </div>
                ) : (
                    <div className="w-[95%] mx-auto pt-10 relative">
                        <div className="bg-green-50 border border-green-200 rounded-xl p-6 shadow-sm relative">
                            <button
                                onClick={handleDeleteGuestyConnection}
                                className="absolute top-4 right-4 hover:bg-red-50
                                font-medium text-sm px-3 py-1.5 rounded-md transition-all shadow-sm" style={{border: '1px solid red', color: 'red'}}
                            >
                                Delete
                            </button>

                            <h2 className="text-xl font-semibold text-green-700 flex items-center gap-2">
                                ✅ Connected to Guesty
                            </h2>
                            <p className="text-sm text-gray-600 mt-2">
                                Your account is successfully linked to Guesty. You can now sync your property listings
                                anytime.
                            </p>

                            <div className="mt-4 text-sm text-gray-700">
                                <div><strong>Client ID:</strong> {hostInfo.guesty_client_id?.slice(0, 8)}•••••••</div>
                                <div className="mt-1"><strong>Client
                                    Secret:</strong> {hostInfo.guesty_client_secret?.slice(0, 4)}••••••••
                                </div>
                            </div>

                            <button
                                onClick={syncGuestyProperties}
                                disabled={loading}
                                className={`mt-6 w-fit bg-[#00B227] text-white font-semibold py-2 px-5 rounded-lg shadow-md transition-all hover:bg-green-600 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                            >
                                {loading ? "Syncing..." : "Sync Guesty Properties Again"}
                            </button>
                        </div>
                    </div>

                )}
            </div>
            <ToastContainer/>
        </div>
    );
}

export default HostDashboard;
